<div *ngIf="surveyAvailabilityChecked && noOpenSurveys" class="survey-card">
  <div class="survey-body" style="text-align: center; padding: 4rem 0;">
    <h3 style="font-size: 1.5rem; color: black; font-weight: 400; margin-bottom: 1rem;">No open surveys are available right now.</h3>
    <p style="font-size: 1.13rem; color: #666; font-weight: 400; margin-bottom: 0;">
      Please check back after a survey is opened.
    </p>
  </div>
</div>

<div *ngIf="surveyAvailabilityChecked && surveyClosed && !noOpenSurveys" class="survey-card">
  <div class="survey-body" style="text-align: center; padding: 4rem 40;">
    <h3 style="font-size: 1.5rem; color: black; font-weight: 400; margin-bottom: 1.5rem;">The survey is now closed and no longer accepting responses—thank you for your interest!</h3>
    <p style="font-size: 1.13rem; color: #b71c1c; font-weight: 400; margin-bottom: 1rem;">
      If you have any questions, feel free to reach out to Rahul Balakrishnan.<br>	
      We’ll be sure to let you know when it opens again.
    </p>
  </div>
</div>
<div *ngIf="surveyAvailabilityChecked && !surveyClosed && !noOpenSurveys && step==1" class="survey-card">
  <div class="survey-header">
    <div>
      <h2 class="survey-title">Welcome to the PHI Survey!</h2>
      <span class="survey-time"><em>Estimated time: 5 minutes</em></span>
    </div>
    <button class="flexbtn" style="width: 140px;" (click)="start()">
      Start Survey <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
  <div class="survey-body">
    <p class="survey-intro">
      Hi there! Thanks for taking the time to fill out the PHI (Product Health Index) survey.
    </p>
    <p>      This survey is part of a renewed and structured effort to consistently measure product health over time —
      your input is essential to making it meaningful.<br><br>
      While product health includes multiple aspects of performance, this survey focuses specifically on key buying
      factors such as TCO, availability, affordability, and more.<br><br>
      Your responses will help us understand how our products are perceived in the market and guide future investment
      decisions.<br><br>
      <strong>Don’t Miss the Deadline!</strong><br>
      Please submit your responses by <strong>{{ surveyDeadlineLabel }}</strong> so we can include your feedback.
    </p>
    <hr class="section-divider" />

    <h3 class="survey-section-title">Survey Overview</h3>
    <h4 class="survey-section-subtitle">What will you be rating?</h4>
    <p>
      You will be rating engine platforms by market application (e.g., QSK60 for Mining, QSK95 for Rail) across the
      following key parameters.
      Please provide ratings based on your best knowledge and experience, and only for the platforms that you know and
      understand.<br><br>
    </p>
    <ul class="survey-list">
      <li><strong>TCO (Total Cost of Ownership)</strong> – Includes fuel consumption, maintenance, and rebuild cost.
        <em>It excludes the initial price for new first fit engines, which is covered under Affordability.</em></li>
      <li><strong>Affordability</strong> – Initial purchase price for new first fit engines, covering upfront capital
        investment.</li>
      <li><strong>Availability</strong> – Uptime and reliability; reflects how consistently the engine stays
        operational.</li>
      <li><strong>Sustainability</strong> – Emissions capability to meet regulatory standards, and bridge capability
        hybrid solutions or alternative fuels for reduced GHG emissions.</li>
      <li><strong>Productivity</strong> – Engine’s ability to deliver power and better transient performance,
        contributing to machine efficiency and output.</li>
    </ul>
    <p class="survey-list"><em>For descriptions of each parameter, click on the information icon next to each parameter
        header on the survey screen.</em></p>
    <!-- <img class="image" src="assets/tooltip.png" alt="Tooltip Info" /> -->

    <h4 class="survey-section-title">Quick Walkthrough</h4>
    <strong class="survey-section-subtitle">1. Pick Your Segments</strong>
    <ol>

      <ul class="survey-list">
        <li>Choose the market segments you’d like to fill out: <strong>Mining, Rail, O&G, Marine, Defense.</strong>
          Select one or more relevant market segments.</li>
      </ul>


    </ol>
    <strong class="survey-section-subtitle">2. Choose Your Products</strong>
  
      

        <ul class="survey-list">
          <li>Start scoring for all parameters of your chosen products. Select N/A if you are unsure about any specific
            parameter.</li>
          <li>If you choose not to score for a product, leave out all the parameters of that product.</li>
          <li>It is mandatory to score for all parameters or select N/A for any selected product. The system throws out
            an error if any parameter is left out.</li>
        </ul>
        <img class="image" src="assets/new.png" alt="NA Example" />
      

  
    <h4 class="survey-section-subtitle">3. Scoring Guide</h4>
    <ul class="survey-list">
      <li>Rate each factor on a scale of 1 to 10, where 1 means “Market Lagging” and 10 means “Market Leading”. Think of
        “5” as market average score.</li>
      <li>Score definitions are displayed on the top header of the survey screen for easy reference.</li>
      <li>If unsure about an item, select “N/A”.</li>
    </ul>


    <div class="survey-footer">
      <p><strong>Thanks again — your feedback means a lot to us!</strong></p>
    </div>
  </div>
</div>

<div *ngIf="surveyAvailabilityChecked && !surveyClosed && !noOpenSurveys && step==2">
  <div class="btngrp-container">
    <div class="btngrp-container">
      <button class="flexbtn" (click)="step =1">
        <mat-icon>arrow_backward</mat-icon> Back
      </button>
    </div>
    <div class="singlerow">
      <table class="legend-table">
        <tr>
          <td class="legend-cell"><strong>1</strong> – Market lagging</td>
          <td class="legend-cell"><strong>2</strong> – Slightly better than Market lagging</td>
          <td class="legend-cell"><strong>3</strong> – Low performer</td>
          <td class="legend-cell"><strong>4</strong> – Slightly worse than Market average</td>
        </tr>
        <tr>
          <td class="legend-cell"><strong>5</strong> – Market average</td>
          <td class="legend-cell"><strong>6</strong> – Slightly better than Market average</td>
          <td class="legend-cell"><strong>7</strong> – Somewhat better than Market average</td>
          <td class="legend-cell"><strong>8</strong> – Better than Market average</td>
        </tr>
        <tr>
          <td class="legend-cell"><strong>9</strong> – Very close to being Market leading</td>
          <td class="legend-cell"><strong>10</strong> – Market leading</td>
          <td class="legend-cell"><strong>N/A</strong> – Not Applicable/Don't know</td>
        </tr>
      </table>
    </div>
  </div>

  <mat-horizontal-stepper [(selectedIndex)]="selectedTabIndex" linear="false" class="custom-stepper" #stepper>
    <mat-step *ngFor="let segment of marketSegment; let i = index">
      <ng-template matStepLabel>
        <span [ngClass]="{'active-step-label': selectedTabIndex === i}">{{ segment }}</span>
      </ng-template>

      <div class="mat-table-container">
        <table mat-table [dataSource]="marketData[segment]">
          <ng-container matColumnDef="product">
            <th mat-header-cell *matHeaderCellDef class="center-header" style="font-size:19px;">Product</th>
            <td mat-cell *matCellDef="let row" class="text-left">
              {{ row.product }}
            </td>
          </ng-container>

          <ng-container matColumnDef="keycompetitor">
            <th mat-header-cell *matHeaderCellDef style="font-size:19px;">Key Competitor</th>
            <td mat-cell *matCellDef="let row" class="text-left">
              {{ row.keycompetitor }}
            </td>
          </ng-container>

          <ng-container *ngFor="let field of scoreFields" [matColumnDef]="field">
            <th mat-header-cell *matHeaderCellDef>
              <div style="display: flex; align-items: center; position: relative; font-size: 19px;">
                <span style="flex: 1; text-align: center;">{{ field == "TCO" ? field : (field | titlecase) }}</span>
                <mat-icon class="info-icon" [matTooltip]="getToolTip(field)" style="margin-left: auto;">help</mat-icon>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" class="text-left">
              <div
                style="display: flex; flex-direction: row; align-items: center; margin-bottom: 4px; width: 100%; justify-content: center;">
                <span class="slider-label" style="text-align: center; min-width: 32px;color: #000;">{{ row[field]
                  }}</span>
              </div>
              <div class="slider-container"
                style="justify-content: center; align-items: center; display: flex; width: 100%; flex-direction: column;">
                <input type="range" min="0" max="10" step="1" [ngClass]="getSliderClass(row[field])"
                  [ngModel]="row[field]" (ngModelChange)="onSliderChanged(row, field, $event)" style="width: 100%" />
                <div
                  style="display: flex; justify-content: space-between; align-items: center; width: 100%; margin-top: 2px;">
                  <span class="slider-label">0</span>
                  <span class="slider-label"></span>
                  <span class="slider-label">10</span>
                </div>
                <div
                  style="display: flex; justify-content: flex-end; align-items: center; width: 100%; margin-top: 4px;">
                  <mat-checkbox id="na-{{field}}-{{row.product}}" [checked]="row.isNA[field]"
                    (click)="onCheckboxClicked(row, field)" style="margin-right: 2px;"></mat-checkbox>
                  <label for="na-{{field}}-{{row.product}}">N/A</label>
                </div>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="notes">
            <th mat-header-cell *matHeaderCellDef class="center-header">Notes/Comments</th>
            <td mat-cell *matCellDef="let row">
              <mat-form-field style="margin-top: 5px; width: 99%">
                <input matInput [(ngModel)]="row.notes" (ngModelChange)="row.edited = true" type="textarea" />
              </mat-form-field>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </div>
    </mat-step>
  </mat-horizontal-stepper>

  <div class="lower-container">

    <mat-form-field class="notes-field">
      <mat-label>Notes</mat-label>
      <input matInput [(ngModel)]="commonNotes" />
    </mat-form-field>

    <button class="reset" (click)="reset()" mat-flat-button color="warn">
      Reset
    </button>
    <button class="btn" (click)="back()" mat-flat-button color="warn">
      &lt;&lt; Back
    </button>
    <button *ngIf="stepper.selectedIndex !== stepper.steps.length - 1" class="btn" (click)="save('save')"
      mat-flat-button color="primary">
      Next &gt;&gt;
    </button>
    <button *ngIf="stepper.selectedIndex === stepper.steps.length - 1" class="btn" (click)="save('submit')"
      mat-flat-button color="primary">
      Submit
    </button>
  </div>
</div>

<div *ngIf="surveyAvailabilityChecked && !surveyClosed && !noOpenSurveys && step==3" class="survey-card">
  <div class="survey-body" style="text-align: center; padding: 4rem 0;">
    <h3 style="font-size: 1.5rem; color: #174ea6; font-weight: 600; margin-bottom: 1.5rem;">You have successfully
      completed the survey!</h3>
    <p style="font-size: 1.13rem; color: #174ea6; font-weight: 600; margin-bottom: 1rem;"><strong>Thank you for taking
        the time to share your inputs.</strong></p>
    <p style="font-size: 1rem; color: #666; margin-bottom: 1rem; line-height: 1.6;">
      Your insights will be instrumental in helping our organization improve and make informed decisions on our
      products.
    </p>
    <p style="font-size: 1rem; color: #666; line-height: 1.6;">
      We truly appreciate your contribution and support!
    </p>
  </div>
</div>

<!-- <div class="survey-footer">
      <p><strong>Thanks again — your feedback means a lot to us!</strong></p>
    </div> -->
